import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { QuickImportProjectScanMethodsSettings } from '../../../../shared/settings/project/scanMethods';

/**
 * Query key for the org's quick-import scan-methods settings. Shared with the update hook, whose
 * `setQueryData` must target the exact key this query reads.
 */
export const getOrganizationQuickImportScanMethodsSettingsQueryKey = (organizationId: number): QueryKey =>
  ['organization', organizationId, 'settings', 'quick-import-scan-methods'];

/**
 * Fetches the quick-import scan-methods (vendored / snippet) org-default settings.
 */
export default function useOrganizationQuickImportScanMethodsSettings(
  organizationId: number,
  shouldFetch: boolean = true,
) {
  return useQuery({
    queryKey: getOrganizationQuickImportScanMethodsSettingsQueryKey(organizationId),
    queryFn: () =>
      get<QuickImportProjectScanMethodsSettings>(
        `/api/organizations/${organizationId}/settings/projects/quick-import-scan-methods`,
      ),
    enabled: shouldFetch,
  });
}
